import bus from '@/utils/eventBus'

export default {
  doReverser () {
    this.$resource.put(this.schedule.id + '/reverser')
      .then(({data}) => {
        bus.$emit('is-reverser', {show: true})
        this.$emit('close', data)
      })
      .catch(() => {
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/reverser/resources/methods.js